
<template lang="pug">
    .modal
        .modal-background(@click="close")
        .modal-card(style="width: 60%; height: 90%;")
            .modal-card-head
                p.modal-card-title Sélectionner un avis
                button.delete(@click="close")
            .modal-card-body
                
                .content
                    h2 Avis
                ReviewListFilterFlowSimulation(@select_review="select_review")
            .modal-card-foot
                button.button.is-success(@click="validate_selected_review") Sélectionner
                button.button(@click="close") Annuler                    
</template>

<script>
import settings from '@/settings'
import gql from '@/gqlService'
import q from '@/gql/queries'
import mutations from '@/gql/mutations'
import moment from "moment"
import query from '@/gql/queries'
import 'bulma-switch';
import ReviewListFilterFlowSimulation from '@/components/ReviewListFilterFlowSimulation'

export default {
  name: 'ModalSelectReviewForSimulation',
  "props":{
        "selected_assistant_uid": String,
  },
  "components": {
        ReviewListFilterFlowSimulation
  },
  data() {
    return {
        selected_review_uid: null,
  }
  },
  async created() {

  },
  computed: {

  },
  methods: {
    select_review(uid){
        console.log('Selecting review', uid)
        this.selected_review_uid = uid
    },
    validate_selected_review(uid){
    this.$emit("select_review", this.selected_review_uid)
    },
    close(){
        this.$emit('close')
    }
  },
};
</script>

<style scoped>

</style>
